export default __webpack_public_path__ + "static/media/steering-rack.bf548f76.png";